var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFootermenu = function SvgFootermenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#F1F3F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.998 15.668a.332.332 0 0 0-.332.334c0 .183.15.333.333.333.184 0 .334-.15.334-.333a.335.335 0 0 0-.335-.334"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#405261",
    fillRule: "evenodd",
    d: "M11.998 11.667a.332.332 0 0 0-.332.333c0 .183.15.333.333.333.184 0 .334-.15.334-.333a.335.335 0 0 0-.335-.334",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.998 11.667a.332.332 0 0 0-.332.333c0 .183.15.333.333.333.184 0 .334-.15.334-.333a.335.335 0 0 0-.335-.334M11.998 7.665a.331.331 0 0 0-.332.333c0 .184.15.334.333.334.184 0 .334-.15.334-.334a.335.335 0 0 0-.335-.333"
  })));
};
export { SvgFootermenu as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiMmU1YTg2NGIwM2RmODVlOGEwN2Q3Mzk0YTM3N2ZhYmUuc3ZnIjs=";